var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseQueryWidgetConfiguration } from "./base-widget";
import { QueriesClientService } from "../services/queries/queries-client.services";
import { EntityTypeConfigurationHelper } from "../models/basics/basics.models";
import { autoinject, transient } from "aurelia-dependency-injection";
import { DataType } from "../models/queries/queries.models";
import * as Enumerable from "linq";
import { computedFrom } from "aurelia-binding";
import { ChartTypes } from "../views/components/chart/chart";
var ComparisonWidgetConfiguration = /** @class */ (function (_super) {
    __extends(ComparisonWidgetConfiguration, _super);
    function ComparisonWidgetConfiguration(queriesService, entityTypeConfigurationHelper) {
        var _this = _super.call(this, entityTypeConfigurationHelper) || this;
        _this.queriesService = queriesService;
        _this.chartTypes = [ChartTypes.AreaChart, ChartTypes.Line];
        return _this;
    }
    Object.defineProperty(ComparisonWidgetConfiguration.prototype, "propertiesToHide", {
        get: function () {
            return Enumerable.from(this.selectedDataProperties).where(function (x) { return x != null; }).toArray();
        },
        enumerable: false,
        configurable: true
    });
    ComparisonWidgetConfiguration.prototype.entityTypeChanged = function () {
        var _this = this;
        this.queriesService.getNameProperties(this.entityTypeUri.replace(/\s/g, ""))
            .then(function (nameProperties) {
            _this.nameProperties = nameProperties;
            _this.dataProperties = Enumerable.from(nameProperties).where(function (x) { return x.type == DataType.Number || x.type == DataType.Double; }).toArray();
            _this.dateProperties = Enumerable.from(nameProperties).where(function (x) { return x.type == DataType.Date || x.type == DataType.DateTime; }).toArray();
        });
        this.selectedDataProperties = [];
        _super.prototype.entityTypeChanged.call(this);
    };
    ComparisonWidgetConfiguration.prototype.getModel = function (self) {
        var queryFilters = self.queryEditor.selectedFilters;
        var model = {
            title: self.title,
            entityTypeUri: self.entityTypeUri,
            nameProperty: self.nameProperty,
            columns: self.queryEditor.columns,
            queryFilters: queryFilters,
            selectedSavedQueryId: self._queryEditor.selectedSavedQuery ? self._queryEditor.selectedSavedQuery.queryId : -1,
            selectedDataProperties: self.selectedDataProperties,
            dateProperty: self.dateProperty,
            chartType: self.chartType,
        };
        return model;
    };
    ComparisonWidgetConfiguration.prototype.setModelOverride = function (model) {
        this.nameProperty = model.nameProperty;
        this.selectedDataProperties = model.selectedDataProperties;
        this.dateProperty = model.dateProperty;
        this.chartType = model.chartType;
    };
    ComparisonWidgetConfiguration.prototype.add = function () {
        if (!this.selectedDataProperties)
            this.selectedDataProperties = [];
        //don't add anymore comboboxes if there is an empty one
        if (!Enumerable.from(this.selectedDataProperties).any(function (x) { return x == null; }))
            this.selectedDataProperties.push(null);
    };
    ComparisonWidgetConfiguration.prototype.removeProperty = function (index) {
        this.selectedDataProperties.splice(index, 1);
    };
    __decorate([
        computedFrom("selectedDataProperties"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ComparisonWidgetConfiguration.prototype, "propertiesToHide", null);
    ComparisonWidgetConfiguration = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [QueriesClientService, EntityTypeConfigurationHelper])
    ], ComparisonWidgetConfiguration);
    return ComparisonWidgetConfiguration;
}(BaseQueryWidgetConfiguration));
export { ComparisonWidgetConfiguration };
